window.Products.HomeDecor.BedPillowShamStandard = function() {};
window.Products.HomeDecor.BedPillowShamStandard.inherits(window.Products.HomeDecor.BedPillowSham);
window.Products.HomeDecor.BedPillowShamStandard.has_3d = true;
window.Products.HomeDecor.BedPillowShamStandard.id = '89-standard';
window.Products.HomeDecor.BedPillowShamStandard.saveId = 89;
window.Products.HomeDecor.BedPillowShamStandard.slug = 'bed-pillow-sham-standard';
window.Products.HomeDecor.BedPillowShamStandard.dpi = 150;